import { Form } from 'antd';
import { useLocation, Link, useHistory } from 'react-router-dom';
import React from 'react';

import { registerWithEmail } from './authService';
import { AuthLogo, AuthPage, EmailForm } from './AuthComponents';
import { useFetchStatusContext } from 'src/hooks/useFetchStatusContext';

const ACTIONS = {
  registerWithEmail: 'registerWithEmail',
};

const RegisterPage = () => {
  const history = useHistory();
  const location = useLocation();
  const asyncAction = useFetchStatusContext();
  const searchParams = new URLSearchParams(location.search);

  const [form] = Form.useForm();

  const handleEmailRegister = async values => {
    await asyncAction.execute(ACTIONS.registerWithEmail, async () => {
      await registerWithEmail(values.email, values.password);
      history.push(`/user/project/new`)
    });
  };

  return (
    <Form
      form={form}
      name="register"
      initialValues={{ email: '', password: '' }}
      onFinish={handleEmailRegister}
      autoComplete="off"
      layout="vertical"
    >
      <AuthPage>
        <div>
          <AuthLogo />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <EmailForm
              isLogin={false}
              loading={asyncAction.isLoading([ACTIONS.registerWithEmail])}
              disabled={asyncAction.isLoading([ACTIONS.registerWithEmail])}
            />
            <div id="recaptcha-container" />
            <div style={{ marginTop: 24, textAlign: 'center' }}>
              Already have an account? <Link to={`/signin?${searchParams}`}>Log in</Link>
            </div>
          </div>
        </div>
      </AuthPage>
    </Form>
  );
};

export default RegisterPage;
